import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import { MdArrowBack } from "react-icons/md";

import { CodexVersionStatus } from "./CodexDisplay";
import { CODEX } from "rbac/RbacContentProvider";
import { getLoggedInUser } from "services/AuthService";
import { Col, Row } from "react-bootstrap";

const CodexVersionDisplayBar = (props) => {
  const { disableApproveButton } = props;

  const codexVersionState = useSelector((state) => state.codexVersion || {});
    const {
    codexVersion: workingCodexVersion,
    codexCreationDate: workingCodexCreationDate,
    codexVersionId: workingCodexVersionId,
    codexTag: workingCodexVersionTag,
      isWorkingVersionEditable,
      codexVersionStatus,
      editableBy,
    customerLabel: selectedCodexCustomer,
      firstApprovalBy,
  } = codexVersionState;

  const navigate = useNavigate();
  const location = useLocation();

  const loggedInUser = useMemo(() => getLoggedInUser(), []);

    const disableDisplayCodexButton =
    location.pathname === "/cat" || location.pathname === "/cat/codex";

  const shouldAutoDisableApprove =
    firstApprovalBy?.userId === loggedInUser?.uuid &&
    codexVersionStatus === "PARTIALLY_APPROVED";

  const finalDisableApproveButton = shouldAutoDisableApprove
    ? true
    : disableApproveButton;

    return (
      <Row>
        <Col md={12}>
          <Row className="codex-version-display-bar">
            <Col md={2} className="my-auto">
              <Button
                size="sm"
                variant="outline-light"
                style={{ float: "left" }}
                onClick={() => navigate("/cat/codex/dsg")}
                disabled={disableDisplayCodexButton}
              >
                <MdArrowBack /> &nbsp; Display Codex
              </Button>
            </Col>
            <Col md={8} className="my-auto">
              &nbsp; selected codex: &nbsp;
              {workingCodexVersion ? (
                <>
                  <strong>
                    {selectedCodexCustomer} (V{workingCodexVersion}) &nbsp;
                  </strong>
                  <CodexVersionStatus codexVersionStatus={codexVersionStatus} />{" "}
                  &nbsp;
                  {!isWorkingVersionEditable ? (
                    <>
                      <Badge bg="danger" pill>
                        READ ONLY
                      </Badge>
                      &nbsp;
                    </>
                  ) : null}
                </>
              ) : (
                "Not Selected"
              )}
            </Col>
            <Col md={2} className="my-auto">
              {editableBy && editableBy.userId === loggedInUser?.uuid
                ? null
                : CODEX.provideCodexStatusModal(finalDisableApproveButton)}
            </Col>
          </Row>
        </Col>
      </Row>
    );
};

export default CodexVersionDisplayBar;
